import api from "./axiosClient.js";

export const getAttendance = async (date) => {
    const response = await api.get("/attendance", { params: { date } });
    return response.data;
};
export const saveAttendance = async (payload) => {
    const response = await api.post("/attendance", payload);
    return response.data;
};